// COPY de apps/desktop/src/...; dedup em F13 via packages/shared-ui.
import { useId, type ReactNode } from 'react';

export interface TabItem {
  id: string;
  label: string;
  content: ReactNode;
  disabled?: boolean;
}

interface TabsProps {
  items: readonly TabItem[];
  value: string;
  onChange: (id: string) => void;
}

export function Tabs({ items, value, onChange }: TabsProps) {
  const id = useId();
  return (
    <div className="ds-tabs">
      <div className="ds-tabs__list" role="tablist">
        {items.map((tab) => {
          const isActive = value === tab.id;
          const tabId = `${id}-${tab.id}`;
          return (
            <button
              key={tab.id}
              id={tabId}
              type="button"
              role="tab"
              className="ds-tabs__trigger"
              aria-selected={isActive}
              aria-controls={`${tabId}-panel`}
              tabIndex={isActive ? 0 : -1}
              disabled={tab.disabled === true}
              onClick={() => onChange(tab.id)}
            >
              {tab.label}
            </button>
          );
        })}
      </div>
      {items.map((tab) => {
        const tabId = `${id}-${tab.id}`;
        const isActive = value === tab.id;
        if (!isActive) return null;
        return (
          <div
            key={tab.id}
            id={`${tabId}-panel`}
            role="tabpanel"
            aria-labelledby={tabId}
            className="ds-tabs__panel"
          >
            {tab.content}
          </div>
        );
      })}
    </div>
  );
}
